// import React from 'react';
import { UseFormReturn } from 'react-hook-form';

type Props = {
  form: UseFormReturn;
  name: string;
};

export const useSubForm = <T>({
  form,
  name: fieldName
}: Props): UseFormReturn & {
  getName: (name: keyof T) => string;
} => {
  const getName = (name: keyof T) => `${fieldName}.${name.toString()}`;

  return {
    getName,
    ...form
  };
};

export default useSubForm;
